import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDataGenericText, IDataGrouped } from '@app/interfaces/idata-grouped';
import { environment } from '@env/environment';
import { status_code } from 'functions/src/help/status-query';
import { Observable, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private BASE_URL_SERVICE: string = environment.endpoint.apiconfig;

  private configs: { [key: string]: Array<IDataGenericText> } = {};

  constructor(private http: HttpClient) { }

  membershipList(_idEmployer) {

    return this.http.get(this.BASE_URL_SERVICE + `membershipList/${_idEmployer}`);
  }

  postSurvey(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postSurvey/', req);
  }

  postSurveyCategory(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postSurveyCategory/', req);
  }

  getConfiguration(arrConfigurarion: Array<ConfigurationType>) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getConfigurationParam/', { configuration: arrConfigurarion });
  }

  getPositionCategory() {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getPositionCategory/');
  }

  getConfigurationList(configurationName: Array<ConfigurationType>): Observable<{ [key: string]: Array<IDataGenericText> }> {

    const configurationUnloaded: Array<ConfigurationType> = [];

    configurationName.forEach(element => {
      if (!this.configs[element]) {
        configurationUnloaded.push(element)
      }
    });

    if (configurationUnloaded.length === 0)
      return of(this.configs);

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getConfigurationParam/', { configuration: configurationUnloaded }).pipe(
      tap(res => {

        if (res.status_code === status_code.success) {

          configurationUnloaded.forEach(element => {
            this.configs[element] = res?.data[element].map((e: { id: string | number; text: string; add: string | undefined; parent: number | undefined; }) => { return { id: +e.id, text: e.text, additional: e.add, parent: e.parent } })
          });

        }
      }),
      map(() => this.configs)
    );
  }

  public getLocalConfig(key: ConfigurationType): Array<IDataGenericText> {

    if (this.configs[key])
      return this.configs[key];

    return [];
  }

  getDate() {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'date/');
  }

  getArrayGrouped(parentArray: Array<IDataGenericText>, childArray: Array<IDataGenericText>): Array<IDataGrouped> {

    return Object.freeze(parentArray.map(parent => {

      const items = childArray.filter(item => +item.parent === +parent.id).map(x => {
        return {
          id: x.id,
          child: x.text,
          additional: x.additional
        }
      })
      return { parent: parent.text, additional: parent.additional, items: items };
    })) as Array<IDataGrouped>;
  }

}

type ConfigurationType =
  'teaching_carrer_biennium'
  | 'teaching_carrer_section'
  | 'level_grade'
  | 'type_contract'
  | 'position'
  | 'position_category'
  | 'complaint_case_type'
  | 'complaint_protocol_stage';